<template>
    <div>

        <PageHeader>
            <template v-if="variant">{{ variant.gtin }}</template>
            <template #side>
                <ButtonIcon :to="parentRoute">
                    {{ $t('goBack') }}
                </ButtonIcon>
            </template>
        </PageHeader>

        <Card :header="$t('variant')" overlay :loading="loading">
            <template #nav>
                <ButtonIcon variant="primary" @click="editItem()">
                    {{ $t('edit') }}
                </ButtonIcon>
            </template>

            <ErrorMessage :value="error" />


            <div v-if="variant" class="grid-template">

                <div class="label">{{ $t('gtin') }}:</div>
                <div class="value">{{ variant.gtin }}</div>

                <div class="label">{{ $t('code') }}:</div>
                <div class="value">{{ variant.code }}</div>

                <div class="label">{{ $t('url') }}:</div>
                <div class="value">{{ variant.url }}</div>

                <div class="label">{{ $t('description') }}:</div>
                <div class="value">{{ variant.description }}</div>

                <div class="label">{{ $t('spec') }}:</div>
                <div class="value"></div>

                <template v-for="([key, value]) in Object.entries(variant.spec)">
                    <div :key="`label-${key}`" class="label ml-4">{{ key }}:</div>
                    <div :key="`value-${key}`" class="value">{{ value }}</div>
                </template>

                <div class="label">{{ $t('manufacturer') }}:</div>
                <div class="value"></div>

                <div class="label ml-4">{{ $t('id') }}:</div>
                <div class="value">{{ variant.manufacturer && variant.manufacturer.id }}</div>

                <div class="label ml-4">{{ $t('name') }}:</div>
                <div class="value">{{ variant.manufacturer && variant.manufacturer.name }}</div>

                <div class="label">{{ $t('product') }}:</div>
                <div class="value"></div>

                <div class="label ml-4">{{ $t('id') }}:</div>
                <div class="value"><b-link :to="{ name: 'CatalogProductsDetails', params: { id: variant.product.id } }">{{ variant.product.id }}</b-link></div>

                <div class="label ml-4">{{ $t('name') }}:</div>
                <div class="value">{{ variant.product.name }}</div>

                <div class="label ml-4">{{ $t('author') }}:</div>
                <div class="value">{{ variant.product.author }}</div>

                <div class="label ml-4">{{ $t('description') }}:</div>
                <div class="value">{{ variant.product.description }}</div>

                <div class="label ml-4">{{ $t('source') }}:</div>
                <div class="value">{{ variant.product.source }}</div>

                <div class="label ml-4">{{ $t('categories') }}:</div>
                <div class="value">{{ variant.product.categories.map(item => item.name).join(', ') }}</div>

                <div class="label ml-4 mb-auto">{{ $t('images') }}:</div>
                <div class="value">
                    <div class="d-flex gap-3 flex-wrap">
                        <ImageLoader
                            v-for="(image, key) in variant.images"
                            :key="key"
                            :src="image"
                            alt=""
                            size="50"
                            image-height="auto"
                            class="mr-2 flex-shrink-0"
                        />
                    </div>
                </div>

            </div>

        </Card>

        <ModalEdit />

        <Offers />

    </div>
</template>



<script>
    import ImageLoader from '@/components/common/ImageLoader.vue';
    import ModalEdit from './parts/ModalEdit.vue';
    import Offers from './parts/Offers.vue';

    export default {
        name: 'Details',
        components: {
            ImageLoader,
            ModalEdit,
            Offers,
        },
        provide() {
            return {
                parentComponent: this,
            };
        },
        data() {
            return {
                id: this.$route.params.id,
                requestVariant: this.$req('catalog/variants'),
            };
        },
        computed: {
            parentRoute() {
                return this.$route.params.parentUrl ? this.$router.resolve(this.$route.params.parentUrl).resolved : this.$route.matched.slice(-2)[0];
            },
            variant() {
                return this.requestVariant.getData();
            },
            loading() {
                return this.requestVariant.getLoading();
            },
            error() {
                return this.requestVariant.getError();
            },
        },
        methods: {
            fetchVariant() {
                return this.requestVariant.get({ urlParams: { id: this.id } }).catch(() => {});
            },
            editItem() {
                this.$root.$emit('bv::show::modal', 'modal-catalog-product-variant-edit');
            },
        },
        created() {
            this.fetchVariant();
        },
    };
</script>



<style lang="scss" scoped>
    .grid-template {
        display: grid;
        grid-template-columns: minmax(60px, max-content) auto;
        column-gap: 1rem;
        row-gap: 0.4rem;
        align-items: center;

        .label {
            font-weight: bold;
        }
    }
</style>
